"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FerrarinDotVDot = function FerrarinDotVDot(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.297,13.597v-0.314v-1.745c0-0.541-0.297-0.646-1.135-0.646c-0.908,0-1.222,0.122-1.222,0.751v0.279h0.768v-0.227 c0-0.314,0.017-0.367,0.419-0.367c0.332,0,0.349,0.035,0.349,0.367v0.628h-0.803c-0.628,0-0.82,0.297-0.82,0.646v0.436 c0,0.367,0.279,0.663,0.716,0.663h2.042v-0.471H17.297z M16.495,13.353c0,0.244-0.122,0.297-0.297,0.297h-0.297 c-0.192,0-0.262-0.122-0.262-0.297v-0.401c0-0.157,0.105-0.297,0.262-0.297h0.593V13.353z M23.686,13.615v-2.653h-1.169v0.436h0.332 v2.217h-0.332v0.454H24v-0.454C24,13.615,23.686,13.615,23.686,13.615z M20.736,10.892c-0.436,0-0.716,0.541-0.908,0.768v-0.716 h-1.152v0.436h0.314v2.217h-0.314v0.471h1.431v-0.471h-0.297V12.41c0-0.105,0.681-0.96,0.681-0.873v1.187h0.803v-1.327 C21.295,11.084,21.103,10.892,20.736,10.892 M6.179,12.689V11.52c0-0.436-0.332-0.628-1.204-0.628H4.852 c-0.943,0-1.187,0.209-1.187,0.751v1.745c0,0.593,0.349,0.698,1.204,0.716h0.087c0.925-0.017,1.204-0.087,1.204-0.646v-0.454H5.359 v0.227c0,0.314-0.052,0.332-0.436,0.332c-0.38,0-0.419-0.027-0.419-0.332c0-0.135,0-0.541,0-0.541H6.179z M4.503,11.555 c0-0.157,0.052-0.244,0.244-0.244h0.349c0.14,0,0.227,0.07,0.227,0.175v0.908h-0.82V11.555z M22.865,10.403h0.855V9.844h-0.855 V10.403z M0.122,10.403h0.489v3.299H0v0.454h2.269v-0.454H1.501v-1.466h0.436v0.419h0.524v-1.309H1.937v0.384H1.501v-1.327h20.701 V9.844H0.122V10.403z M9.391,10.892c-0.436,0-0.716,0.541-0.908,0.768v-0.716H7.331v0.436h0.314v2.217H7.331v0.471h1.431v-0.471 H8.465V12.41c0-0.105,0.681-0.96,0.681-0.873v1.187h0.803v-1.327C9.949,11.084,9.757,10.892,9.391,10.892 M13.056,10.892 c-0.436,0-0.716,0.541-0.908,0.768v-0.716h-1.152v0.436h0.314v2.217h-0.314v0.471h1.431v-0.471h-0.297V12.41 c0-0.105,0.681-0.96,0.681-0.873v1.187h0.803v-1.327C13.615,11.084,13.423,10.892,13.056,10.892"
  }));
};

FerrarinDotVDot.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
FerrarinDotVDot.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = FerrarinDotVDot;
exports.default = _default;